import { createSlice } from "@reduxjs/toolkit";

/**
 * WeAll Team inbox state shared with the sidebar: the total unread count, kept live by the admin socket
 * (see components/weAllTeam/WeAllTeamRealtime.js). Never persisted - it is re-read on every page load.
 */
export const weAllTeamSlice = createSlice({
  name: "weall_team",
  initialState: { unread: 0 },
  reducers: {
    setWeAllTeamUnread: (state, action) => {
      const value = Number(action.payload);
      state.unread = Number.isFinite(value) && value > 0 ? value : 0;
    },
  },
});

export const { setWeAllTeamUnread } = weAllTeamSlice.actions;
export default weAllTeamSlice.reducer;
